<div class="content">
  <button
    (click)="close()"
    [ngStyle]="{
      background:
        count === 0
          ? 'linear-gradient(90deg, #15dfce 0%, #079994 100%)'
          : '#D8D8D8',
      cursor: count === 0 ? 'pointer' : 'default'
    }"
  >
    已悉知
    <ng-container *ngIf="count !== 0">({{ count }}s)</ng-container>
  </button>
</div>
